import React from "react";
import CodeEditor from "../../../../../../components/elements/CodeEditor";

export default function CodeWebBlockEditor({ block, onChange }) {
    if (!block) return null;

    const config =
        block.config && typeof block.config === "object"
            ? block.config
            : {};

    const files = config.files || {};

    const updateConfig = (patch) => {
        onChange({
            ...block,
            config: {
                ...config,
                ...patch,
            },
        });
    };

    const updateFile = (name, value) => {
        updateConfig({
            files: {
                ...files,
                [name]: value,
            },
        });
    };

    return (
        <div className="space-y-4">
            <div>
                <label className="block text-sm font-medium mb-1">
                    محیط
                </label>

                <select
                    className="w-full p-2 border rounded-lg bg-white"
                    value={config.workspace || "html_css_js"}
                    onChange={(e) =>
                        updateConfig({ workspace: e.target.value })
                    }
                >
                    <option value="html">HTML</option>
                    <option value="html_css">HTML + CSS</option>
                    <option value="html_css_js">
                        HTML + CSS + JavaScript
                    </option>
                </select>
            </div>

            <label className="flex items-center gap-2 text-sm">
                <input
                    type="checkbox"
                    checked={!!config.showCompiler}
                    onChange={(e) =>
                        updateConfig({
                            showCompiler: e.target.checked,
                        })
                    }
                />
                نمایش پیش‌نمایش
            </label>

            <label className="flex items-center gap-2 text-sm">
                <input
                    type="checkbox"
                    checked={!!config.editable}
                    onChange={(e) =>
                        updateConfig({
                            editable: e.target.checked,
                        })
                    }
                />
                قابل ویرایش
            </label>

            <div>
                <label className="block text-sm font-medium mb-1">
                    HTML
                </label>

                <CodeEditor
                    value={files.html || ""}
                    onChange={(code) => updateFile("html", code)}
                    language="html"
                    height={250}
                />
            </div>

            {config.workspace !== "html" && (
                <div>
                    <label className="block text-sm font-medium mb-1">
                        CSS
                    </label>

                    <CodeEditor
                        value={files.css || ""}
                        onChange={(code) => updateFile("css", code)}
                        language="css"
                        height={250}
                    />
                </div>
            )}

            {config.workspace === "html_css_js" && (
                <div>
                    <label className="block text-sm font-medium mb-1">
                        JavaScript
                    </label>

                    <CodeEditor
                        value={files.js || ""}
                        onChange={(code) => updateFile("js", code)}
                        language="javascript"
                        height={250}
                    />
                </div>
            )}
        </div>
    );
}